export const isNullOrUndefined = (item: string | number): boolean => {
    return item === null || item === undefined
}
